import { post } from '../../Services/http';
import { translate } from '../../Services/translation';
import { IImageRepositoryItem } from './types';

export const downloadItemsAsync = async (
  items: IImageRepositoryItem[]
) => {
  if (items.length == 0) return;

  const url = `/api/imagerepository/download`;
  try {
    const res = await post(url, items);
    if (res.ok) {
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'product-images-hd.zip';
      link.click();

      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
        link.remove();
      }, 0);
    }
  } catch (err) {
    alert(translate('general.error'));
    console.error(err);
  }
};

export const groupByArticleNumber = (
  items: IImageRepositoryItem[]
): Record<string, IImageRepositoryItem[]> => {
  return items.reduce((groups, item) => {
    const { articleNumber } = item;
    if (!groups[articleNumber]) {
      groups[articleNumber] = [];
    }
    groups[articleNumber]!.push(item);
    return groups;
  }, {} as Record<string, IImageRepositoryItem[]>);
};

export const bytesToString = (byteCount: number): string => {
  const suf: string[] = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
  if (byteCount === 0) return '0' + suf[0];
  const bytes: number = Math.abs(byteCount);
  const place: number = Math.floor(Math.log(bytes) / Math.log(1024));
  const num: number =
    Math.round((bytes / Math.pow(1024, place)) * 10) / 10;
  return (Math.sign(byteCount) * num).toString() + ` ${suf[place]}`;
};
